import { faCalendarDay } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Calendar, DropdownMenu } from '@nexelem/components';
import { useKanbanFilterStore } from '../hooks/useKanbanFilterStore';
import { useDateFormatter } from '@nexelem/utils';
import { useCustomTranslation } from '../../../../hooks';
import { useState } from 'react';
import { KanbanShiftSelector } from './KanbanShiftSelector';

export const KanbanFilterDate = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { tWrapper } = useCustomTranslation('common');
  const setKanbanDate = useKanbanFilterStore((state) => state.setKanbanDate);
  const kanbanDate = useKanbanFilterStore((state) => state.kanbanDate);
  const [dateValue, setDateValue] = useState<Date>(kanbanDate);
  const formatDate = useDateFormatter({ displayWithHours: false });

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (open) {
      setDateValue(kanbanDate);
    }
  };

  const handleApply = () => {
    setKanbanDate(dateValue);
    setIsOpen(false);
  };

  return (
    <>
      <DropdownMenu.Root open={isOpen} onOpenChange={handleOpenChange}>
        <DropdownMenu.Trigger>
          <Button StartIcon={<FontAwesomeIcon icon={faCalendarDay} />} variant="text">
            {formatDate(kanbanDate)}
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.CalendarContainer
          footer={
            <Button className="ml-auto" onClick={handleApply}>
              {tWrapper('apply')}
            </Button>
          }
        >
          <Calendar
            required
            captionLayout="dropdown"
            defaultMonth={dateValue}
            mode="single"
            selected={dateValue}
            onSelect={setDateValue}
          />
        </DropdownMenu.CalendarContainer>
      </DropdownMenu.Root>
      <KanbanShiftSelector />
    </>
  );
};
